// extracted by mini-css-extract-plugin
export var attachmentContainer = "_kq-0";
export var fileList = "_kq-2";
export var removeFileButton = "_kq-1";